import React from 'react';
import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { motion } from 'framer-motion';
import { convertirLetraMayus } from '../../../helpers/convertirLetraMayus';
import { Button } from '../../../components/surveys/surveys/client/Button';

export const Introduction = (props) => {

	const classes = useStyles();
	const { data, action } = props;

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1}}
			transition={{ duration: 1.5 }}
		>	
			<Grid container justifyContent='center'>
				<Grid item xs={ 10 } sm={ 9 } md={ 10 } lg={ 10 } xl={ 8 } alignItems='center'>
					<h1 className={ classes.title }>{ convertirLetraMayus(data) }</h1>
					<Button 
						title='Comenzar' 
						action={ action }
						breakPoints={[ 6, 5, 3, 2 ]}
					/>
				</Grid>
			</Grid>
		</motion.div>
	)
}

const useStyles = makeStyles({
	title: {
		color: '#fff',
		textAlign: 'center',
		margin: '50px 0px',
		letterSpacing: 1,
		fontSize: 'clamp(1.2rem, 4vw, 2.5rem)',
	}
});